import React from 'react';
import { GenericP, GenericDiv } from 'commonStyles';
import { SpriteIcon } from '../wallet/WalletStyles';

const NoData = ({ heading, description, bottom_M, top_P }) => (
	<GenericDiv bottom_M={bottom_M || 100} top_M={top_P || 100}>
		<GenericP text_align='center'>
			<SpriteIcon icon='noresult' />
		</GenericP>

		<GenericP top_M='20' fsize='16px' text_align='center' f_weight='900' bottom_M={8}>{heading}</GenericP>
		<GenericP
			fsize='12px'
			text_align='center'>
			{description}
		</GenericP>
	</GenericDiv>
);

export default NoData;
